import SchemaFormRender from "@/components/Schema/SchemaFormRender";

const SchemaFormView = ({
  form,
  schemaJson,
}: {
  form: any;
  schemaJson: any;
}) => {
  return <SchemaFormRender form={form} schemaJson={schemaJson} />;
};

export default SchemaFormView;
